"use client";

import { c as _c } from "react/compiler-runtime";
import ImageComponent from "@/components/ui/image";
import { getDeviceType } from "@/utils/device";
import React, { useMemo } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
const CustomDot = t0 => {
  const $ = _c(3);
  const {
    onClick,
    active
  } = t0;
  const t1 = `inline-block mx-1 md:mx-1 h-1 md:h-2 rounded-full cursor-pointer transition-all duration-300 ease-in-out bg-white ${active ? "w-3 md:w-5" : "w-1 md:w-2"}`;
  let t2;
  if ($[0] !== onClick || $[1] !== t1) {
    t2 = <li className={t1} onClick={onClick} />;
    $[0] = onClick;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const responsive = {
  superLargeDesktop: {
    breakpoint: {
      max: 4000,
      min: 3000
    },
    items: 1
  },
  desktop: {
    breakpoint: {
      max: 3000,
      min: 1024
    },
    items: 1
  },
  tablet: {
    breakpoint: {
      max: 1024,
      min: 464
    },
    items: 1
  },
  mobile: {
    breakpoint: {
      max: 464,
      min: 0
    },
    items: 1
  }
};
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { sanitizeText } from "@/utils/seo";
const CustomLeftArrow = t0 => {
  const $ = _c(4);
  const {
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      top: "50%",
      transform: "translateY(-50%)"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ChevronLeft className="w-4 h-4 md:w-5 md:h-5" strokeWidth={2.5} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onClick) {
    t3 = <Button onClick={onClick} variant="ghost" size="icon" className="absolute left-2 md:left-3 z-10 rounded-full shadow-sm text-stone-700 bg-white/50 hover:bg-white/80 active:scale-95 transition-all duration-200 flex items-center justify-center size-8 md:size-10" style={t1} aria-label="Previous image" type="button">{t2}</Button>;
    $[2] = onClick;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
const CustomRightArrow = t0 => {
  const $ = _c(4);
  const {
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      top: "50%",
      transform: "translateY(-50%)"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ChevronRight className="w-4 h-4 md:w-5 md:h-5" strokeWidth={2.5} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onClick) {
    t3 = <Button onClick={onClick} variant="ghost" size="icon" className="absolute right-2 md:right-3 z-10 rounded-full shadow-sm text-stone-700 bg-white/50 hover:bg-white/80 active:scale-95 transition-all duration-200 flex items-center justify-center size-8 md:size-10" style={t1} aria-label="Next image" type="button">{t2}</Button>;
    $[2] = onClick;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
const ProductCarousel = t0 => {
  const $ = _c(6);
  const {
    media,
    altText
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getDeviceType();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const deviceType = t1;
  if (!media || media.length === 0) {
    return null;
  }
  let t2;
  if ($[1] !== altText) {
    t2 = (url, index) => <div key={url} className="flex justify-center relative w-full h-full"><ImageComponent className="w-full h-full object-cover" src={url || ""} width={1266} height={1088} sizes="(min-width: 1024px) 633px, 100vw" quality={80} alt={altText ? sanitizeText(altText) : "Product"} fetchPriority={index === 0 ? "high" : "auto"} priority={index === 0} preload={false} unoptimized={true} /></div>;
    $[1] = altText;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const renderImage = t2;
  let t3;
  if ($[3] !== media || $[4] !== renderImage) {
    t3 = <div className="relative flex flex-col items-center justify-start w-full space-y-4"><div className="relative mt-2 w-full aspect-square  overflow-hidden  ring-1 ring-black/5">{media.length > 1 ? <Carousel responsive={responsive} infinite={true} arrows={true} customLeftArrow={<CustomLeftArrow />} customRightArrow={<CustomRightArrow />} showDots={true} customDot={<CustomDot />} autoPlay={true} ssr={true} deviceType={deviceType}>{(media || []).map(renderImage)}</Carousel> : renderImage(media[0], 0)}</div></div>;
    $[3] = media;
    $[4] = renderImage;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default ProductCarousel;